// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  C3SERVER: 'https://dev.ultrasimweb.basf.com/',
  USIM_HOST: 'https://dev.ultrasimweb.basf.com/ultrasim',
  deployment: 'ultrasimweb',
  TOKEN: '',
  APP: 'foaming',
  // for dev ultrasimweb
  clientId: '165c0e60-ef93-49ea-99e0-7408ee601b14',
  grantType: 'authorization_code',
  scope: 'UltrasimWeb_DEVL',
  resourceServer: 'UltrasimWeb_DEVL',
  responseType: 'code',
  googleAuthurl: '',
  authorization_endpoint: 'https://federation-qa.basf.com/nidp/oauth/nam/authz',
  federationServiceConfigUrl: 'https://federation-qa.basf.com/nidp/oauth/nam/.well-known/openid-configuration',
  federation_attribute: '/VirtualAttribute[@ldap:targetAttribute="UltrasimRoles"]',
  redirectUri: 'https://dev.ultrasimweb.basf.com',
  getTokenUrl: 'https://dev.ultrasimweb.basf.com/ultrasim/api/get_token/',
  // USIM_HOST: 'https://dev.ultrasimweb.basf.com/ultrasim',
  // AUTH: 'ultrasimweb',

  // app specific
  mainColor: '#f49602',
  headerColor: '#212529 !important',
  emptyProjectLink: 'newFoaming',
  projectLink: 'versions',
  newVersionLink: 'newFoaming',
  versionLink: 'result',
  newProjectLink: 'newFoaming',
};
